
















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  private page: string = '';
  public created() {
    this.page  = this.$route.name || 'home';
  }
  private toUrl(name: string) {
    this.$router.push({ name });
  }
}
